"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WaitinglistSchema = void 0;
exports.WaitinglistSchema = {
  type: 'object',
  required: ['number_of_participants'],
  additionalProperties: false,
  properties: {
    number_of_participants: {
      type: 'number',
      minimum: 0
    },
    page_ids: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    continue_email_campaign_id: {
      type: ['string', 'null']
    },
    waitinglist_email_campaign_id: {
      type: ['string', 'null']
    },
    waitinglist_promotion_email_campaign_id: {
      type: ['string', 'null']
    },
    waitinglist_pending_stage_name: {
      type: 'string'
    },
    waitinglist_stage_name: {
      type: 'string'
    },
    waitinglist_completed_stage_name: {
      type: 'string'
    },
    cancellation_workflow_id: {
      type: ['string', 'null']
    },
    next_workflow_ids: {
      type: 'object',
      properties: {
        next_workflow: {
          type: ['string', 'null']
        }
      }
    }
  }
};
